import React, { useEffect, useState } from "react";
import { useFormContext, Controller, Form } from "react-hook-form";
import ModalBox from "../modals/ModalBox";
import NoData from "../../Pages/Relationship/DetailsContent/NoData";

function PopupMultiSelect({ name, label, rules, options, className, showSearch, onOpen, onClose, inputlabel }) {
  const {
    control,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useFormContext();
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Add state for search term
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  
  const openModal = () => {
    setShowModal(true);
    onOpen && onOpen();
  };

  const handleSelect = (option) => {
    setSelectedValues((prev) => {
      const exists = prev.includes(option.id);
      if (exists) {
        return prev.filter(id => id !== option.id);
      } else {
        return [...prev, option.id];
      }
    });
  };

  const handleConfirm = () => {
    setValue(name, selectedValues)
    // Get names of selected options
    const selectedNames = options.filter(option => selectedValues.includes(option.id)).map(option => option.name).join(', ');
    setSelectedOption(selectedNames);
    setShowModal(false);
    setSearchTerm('');
    trigger(name);
  };

  useEffect(() => {
    setSelectedValues(watch(name))
  }, [watch(name)])
  
  return (
    <div className={className}>
      <label htmlFor={name} className="form-label">
        {label}
      </label>

      <Controller
        name={name}
        control={control}
        defaultValue=""
        rules={rules}
        render={({ field }) => (
          <div className="row">
            <div onClick={() => openModal()}>
              <input className="form-control" value={selectedOption || watch(inputlabel)} readOnly/>
            </div>
            <ModalBox
              isShow={showModal}
              handleClose={() => {
                onClose && onClose();
                setShowModal(false);
              }}
              modalSize="md"
              hasData={true}
              // hideClose={true}
            >
              <div className="text-center position-relative">
                <h3 className="modal-title mb-3 mt-0">{label}</h3>
              </div>
              {!!showSearch && (
              <div className="row">
                <div className="col-12 mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              )}
              <div className="row">
                {options?.length > 0 ? (
                  (() => {
                    const filteredOptions = options.filter((option) =>
                      option.name
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    );

                    return filteredOptions.length > 0 ? (
                      filteredOptions.map((option, index) => (
                        <div key={index} className="col-12 mb-3">
                          <div className="row" onClick={() => handleSelect(option)}>
                            <div className="col-11">
                              <label
                                className="form-check-label ms-1"
                                htmlFor={name + `-radio-` + option.id}
                              >
                                <div className="d-flex align-items-center justify-content-center justify-content-md-start flex-wrap text-center ">
                                  <div className="mt-2 mt-md-0 ms-lg-1 text-lg-start rltnshp-txt">
                                    <p className="mb-1">{option.name}</p>
                                  </div>
                                </div>
                              </label>
                            </div>
                            <div className="col-1 d-flex align-items-center">
                              <div className="form-check form-checked form-checkbox">
                                <input
                                  // name={name}
                                  type="checkbox"
                                  value={option.id}
                                  className="form-check-input"
                                  id={name + `-radio-` + option.id}
                                  checked={selectedValues.includes(option.id)}
                                  />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <NoData />
                    );
                  })()
                ) : (
                  <NoData />
                )}
              </div>

              <div className="row">
                <div className="col-12">
                  <button
                    type="button"
                    className="btn btn-primary rounded-pill w-100 my-2 p-2"
                    onClick={handleConfirm}
                    disabled={!selectedValues}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </ModalBox>
          </div>
        )}
      />

      {errors[name] && <span className="error">{errors[name].message}</span>}
    </div>
  );
}

export default PopupMultiSelect;
